import { render } from "./BrandShow.vue?vue&type=template&id=6978da89"
import script from "./BrandShow.vue?vue&type=script&lang=js"
export * from "./BrandShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__